import { render } from "./BuyerView.vue?vue&type=template&id=6bc61e56&lang=html"
import script from "./BuyerView.vue?vue&type=script&lang=js"
export * from "./BuyerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__